import { render } from "./AppMain.vue?vue&type=template&id=db7e196c&scoped=true&ts=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=db7e196c&lang=scss&scoped=true"
import "./AppMain.vue?vue&type=style&index=1&id=db7e196c&lang=scss"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db7e196c"]])

export default __exports__